module.exports = __webpack_public_path__ + "img/edit_file_blue.d3336416.svg";